const menuItems = ["Master Files", "Modules", "Reports", "Accounting", "Utility"];

export { menuItems };
